import { render, staticRenderFns } from "./you.vue?vue&type=template&id=02a890f3&scoped=true&"
import script from "./you.vue?vue&type=script&lang=js&"
export * from "./you.vue?vue&type=script&lang=js&"
import style0 from "./you.vue?vue&type=style&index=0&id=02a890f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a890f3",
  null
  
)

export default component.exports